const pagination = {
  pageSize: 100,
};
export { pagination };
